<template>
  <div>
    <div v-if="$store.state.applicationInProgress && !(allowedCount() == 1 && allowed('idc'))" data-notify="container" class="col-md-12 alert alert-warning alert-with-icon">
      <span data-notify="icon" class="fa fa-exclamation"></span>
      <span data-notify="message" style="font-size: 120%">Please be sure to add <b>ALL</b> verifications you would like included in your application, along with the requested documentation, as the application is <b>closed</b> after submission.</span>
    </div>
    <div class="row xstarter">
      <!-- <div v-for="checkType, index in checkTypes" :class="'col col-sm-' + ((12 / (allowedCount() > 4 ? 4 : allowedCount())) * 2) + ' col-lg-' + (12 / (allowedCount() > 4 ? 4 : allowedCount()))"> -->
      <div v-for="checkType, index in checkTypes" :class="'col-lg-4'" v-if="index < 4">
        <div class="card" v-loading="checkType.name == 'Identity Document' && idDisabledTime" element-loading-text="Identity Document checking is down for maintenance from 00:00 June 7th UTC until 11:00 June 7th UTC.">
          <div class="card-header">
              <h4 class="card-title text-center">
                  <i :class="checkType.icon" :style="checkType.style" /><br>
                  <div>{{checkType.name}}</div>
              </h4>
          </div>
          <div class="card-content row text-center">
            <p>
              <el-input-number v-model="counts[checkType.numName]" :name="checkType.numName" :min="checkType.min" :max="checkType.max"></el-input-number>
              <span v-if="checkType.min == checkType.max" class="help-block">
                Must be exactly {{checkType.min}}
              </span>
              <span v-else class="help-block">
                {{checkType.help}}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row xstarter">
      <!-- <div v-for="checkType, index in checkTypes" :class="'col col-sm-' + ((12 / (allowedCount() > 4 ? 4 : allowedCount())) * 2) + ' col-lg-' + (12 / (allowedCount() > 4 ? 4 : allowedCount()))"> -->
      <div v-for="checkType, index in checkTypes" :class="'col-lg-4'" v-if="index >= 4">
        <div class="card">
          <div class="card-header">
              <h4 class="card-title text-center">
                  <i :class="checkType.icon" :style="checkType.style" /><br>
                  <div>{{checkType.name}}</div>
              </h4>
          </div>
          <div class="card-content row text-center">
            <p>
              <el-input-number v-model="counts[checkType.numName]" :name="checkType.numName" :min="checkType.min" :max="checkType.max"></el-input-number>
              <span v-if="checkType.min == checkType.max" class="help-block">
                Must be exactly {{checkType.min}}
              </span>
              <span v-else class="help-block">
                {{checkType.help}}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="verification-individual col-md-12 card">
      <div class="card-header">
        <h4 class="card-title">Individual's Details</h4>
      </div>
      <div class="card-content row">
        <div class="form-horizontal">
          <dynamic-input name="firstname" label="First name" placeholder="First name" v-model="firstname" :validations="{required:true}" :hasPreviousCheck="true"/>
          <dynamic-input name="middlename" label="Middle name" placeholder="Middle name" v-model="middlename" />
          <dynamic-input name="lastname" label="Last name" placeholder="Last name" v-model="lastname" :validations="{required:true}" :hasPreviousCheck="true"/>
          <dynamic-input name="dob" label="Date of birth" placeholder="Date of birth" v-model="dob" :validations="{required:true, date_format:'dd/MM/yyyy', min_age:15}" type="DATE" :hasPreviousCheck="true"/>
          <dynamic-input name="reference" v-if="application == null" :label="$store.getters.refLabel" placeholder="Reference" v-model="customerReference" :validations="{required:$store.state.refRequired}" :description="!$store.state.refRequired ? 'The reference number used to track this case in your internal system if you have one.' : null" />
        </div>
      </div>
    </div>

    <button type="button" v-if="verifications.length > 0" @click="$emit('cancelStart')" class="btn btn-wd" style="margin-bottom: 20px">Cancel</button>

    <div class="pull-right">
      <small class="text-danger" v-if="errors.any()">
        Please resolve the errors above.
      </small>
      <br v-if="errors.any()"/>
      <small class="text-danger" v-if="noneSelected">
        At least one type of check must be selected
      </small>
      <br v-if="noneSelected"/>
      <button type="button" @click.prevent="validate" class="btn btn-wd btn-fill btn-move-right pull-right" v-bind:disabled="noneSelected" v-bind:class="{'btn-disabled': noneSelected}" style="margin-bottom: 20px">Next<span class="btn-label"><i class="ti-angle-right"></i></span></button>
    </div>
  </div>
</template>
<script>
  import DynamicInput from 'src/views/Verifications/components/DynamicInput'
  import PSwitch from 'src/components/Switch.vue'

  import moment from 'moment'

  import { Loading } from 'element-ui';
  import LogRocket from 'logrocket';

  export default {
    name: "verification-start",
    components: {
      DynamicInput,
      PSwitch
    },
    inject: ['$validator'],
    props: {
      application: {type: Object, default() {
        return null
      }},
      verifications: {type: Array}
    },
    data () {
      return {
        firstname: null,
        middlename: null,
        lastname: null,
        dob: null,
        customerReference: null,
        counts: {
          eduNum: 0,
          empNum: 0,
          pliNum: 0,
          pceNum: 0,
          idcNum: 0,
          hscNum: 0,
          elcNum: 0,
          arfNum: 0
        }
      }
    },
    computed: {
      idDisabledTime() {
        let startTime = moment('2025-06-07T00:00:00Z');
        let endTime = moment('2025-06-07T11:00:00Z');
        return moment().isBetween(startTime, endTime);
      },
      noneSelected() {
        return (
          this.counts.eduNum == 0 && 
          this.counts.empNum == 0 && 
          this.counts.pliNum == 0 && 
          this.counts.pceNum == 0 && 
          this.counts.idcNum == 0 && 
          this.counts.hscNum == 0 && 
          this.counts.elcNum == 0 && 
          this.counts.arfNum == 0)
      },
      checkTypes() {
          var types = []
          var type = null

          type = this.allowed('edu')
          if(type) {
            types.push({
              name: 'Higher Education',
              icon: 'qc2-edu fa-3x',
              numName: 'eduNum',
          // TODO SELTS CONFIRM RIGHT MERGE
              // help: (type.min && type.max && type.min == 1 && type.max == 1) ? 'Highest qualification required' : 'Add one per qualification.',
              // min: type.min ? type.min : 0,
              // max: type.max ? type.max : 10
              help: 'Add one per qualification.',
              min: this.allowedMin('edu'),
              max: this.allowedMax('edu'),
            })
          }
          type = this.allowed('hsc')
          if(type) {
            types.push({
              name: 'High School',
              icon: 'qc2-bul fa-3x ',
              numName: 'hscNum',
          // TODO SELTS CONFIRM RIGHT MERGE
              // help: (type.min && type.max && type.min == 1 && type.max == 1) ? 'Exactly one required' : 'Add one per school.',
              // min: type.min ? type.min : 0,
              // max: type.max ? type.max : 10
              help: 'Add one per school.',
              min: this.allowedMin('hsc'),
              max: this.allowedMax('hsc'),
            })
          }
          type = this.allowed('emp')
          if(type) {
            types.push({
              name: 'Employment History',
              icon: 'qc2-emp fa-3x',
              numName: 'empNum',
          // TODO SELTS CONFIRM RIGHT MERGE
              // help: (type.min && type.max && type.min == 1 && type.max == 1) ? 'Exactly one required' : 'Add one per institute.',
              // min: type.min ? type.min : 0,
              // max: type.max ? type.max : 10
              help: 'Add one per institute.',
              min: this.allowedMin('emp'),
              max: this.allowedMax('emp'),
            })
          }
          type = this.allowed('pli')
          if(type) {
            types.push({
              name: 'Professional License',
              icon: 'qc2-pli fa-3x',
              numName: 'pliNum',
          // TODO SELTS CONFIRM RIGHT MERGE
              // help: (type.min && type.max && type.min == 1 && type.max == 1) ? 'Exactly one required' : 'Add one per license.',
              // min: type.min ? type.min : 0,
              // max: type.max ? type.max : 10
              help: 'Add one per license.',
              min: this.allowedMin('pli'),
              max: this.allowedMax('pli'),
            })
          }
          type = this.allowed('pce')
          if(type) {
            types.push({
              name: 'Professional Certificate',
              icon: 'qc2-pce fa-3x',
              numName: 'pceNum',
          // TODO SELTS CONFIRM RIGHT MERGE
              // help: (type.min && type.max && type.min == 1 && type.max == 1) ? 'Exactly one required' : 'Add one per certification.',
              // min: type.min ? type.min : 0,
              // max: type.max ? type.max : 10
              help: 'Add one per certification.',
              min: this.allowedMin('pce'),
              max: this.allowedMax('pce'),
            })
          }
          type = this.allowed('idc')
          if(type) {
            types.push({
              name: 'Identity Document',
              icon: 'fa fa-3x fa-id-badge',
              numName: 'idcNum',
          // TODO SELTS CONFIRM RIGHT MERGE
              // help: (type.min && type.max && type.min == 1 && type.max == 1) ? 'Exactly one required' : 'Max one per individual.',
              // min: type.min ? type.min : 0,
              // max: type.max ? type.max : 10,
              help: 'Max one per individual.',
              min: this.allowedMin('idc'),
              max: this.allowedMax('idc'),
              // style: 'position: relative; left: -100px'
            })
          }
          type = this.allowed('elc')
          if(type) {
            types.push({
              name: 'SELT Validation',
              icon: 'fa fa-3x fa-comments-o',
              numName: 'elcNum',
          // TODO SELTS CONFIRM RIGHT MERGE
              // help: (type.min && type.max && type.min == 1 && type.max == 1) ? 'Exactly one required' : 'Max one per individual.',
              // min: type.min ? type.min : 0,
              // max: type.max ? type.max : 10,
              help: 'Add one per validation.',
              min: this.allowedMin('elc'),
              max: this.allowedMax('elc'),
              // style: 'position: relative; left: -20px'
            })
          }
          type = this.allowed('arf')
          if(type) {
            types.push({
              name: 'Academic Reference',
              icon: 'fa fa-3x fa-university',
              numName: 'arfNum',
          // TODO SELTS CONFIRM RIGHT MERGE
              // help: (type.min && type.max && type.min == 1 && type.max == 1) ? 'Exactly one required' : 'Max one per individual.',
              // min: type.min ? type.min : 0,
              // max: type.max ? type.max : 10,
              help: 'Add one per reference.',
              min: this.allowedMin('elc'),
              max: this.allowedMax('elc'),
              // style: 'position: relative; left: -20px'
            })
          }
          return types
        }
    },
    mounted() {
      if(this.$route.query.nedu) {
        this.counts.eduNum = this.$route.query.nedu
        this.$route.query.nedu = null
      } else if(this.$store.state.initInstitute) { // Shouldn't hit this as "New" will skip "Start"
        this.counts.eduNum++
        this.build()
      }
      if(this.$route.query.nemp) {
        this.counts.empNum = this.$route.query.nemp
        this.$route.query.nemp = null
      }
      if(this.$route.query.npli) {
        this.counts.pliNum = this.$route.query.npli
        this.$route.query.npli = null
      }
      if(this.$route.query.npce) {
        this.counts.pceNum = this.$route.query.npce
        this.$route.query.npce = null
      }
      if(this.$route.query.nidc) {
        this.counts.idcNum = this.$route.query.nidc
        this.$route.query.nidc = null
      }
      if(this.$route.query.nhsc) {
        this.counts.hscNum = this.$route.query.nhsc
        this.$route.query.nhsc = null
      }
      if(this.$route.query.nelc) {
        this.counts.elcNum = this.$route.query.nelc
        this.$route.query.nelc = null
      }
      if(this.$route.query.narf) {
        this.counts.arfNum = this.$route.query.narf
        this.$route.query.narf = null
      }
    },
    methods: {
      allowed(type) {
        if(this.application != null && this.application.allowedTypes) {
          // TODO SELTS CONFIRM RIGHT MERGE
          // var allowedTypes = JSON.parse(this.application.allowedTypes)
          // if(allowedTypes.includes(type)) {
          //   return true
          // } else {
          //   return allowedTypes.find((t) => t.type && t.type == type)
          // }
          return JSON.parse(this.application.allowedTypes).map(type => type.key).includes(type)
        }
        return this.$store.getters.allowed(type)
      },
      allowedCount() {
        if(this.application != null && this.application.allowedTypes) {
          return JSON.parse(this.application.allowedTypes).length
        }
        return this.$store.getters.allowedTypes.length
      },
      allowedMin(type) {
        if(this.application != null && this.application.allowedTypes) {
          const typeObj = JSON.parse(this.application.allowedTypes).find(t => t.key === type);
          return typeObj ? typeObj.min : 0;
        }
        return 0
      },
      allowedMax(type) {
        if(this.application != null && this.application.allowedTypes) {
          const typeObj = JSON.parse(this.application.allowedTypes).find(t => t.key === type);
          return typeObj ? typeObj.max : 10;
        }
        if(type === 'idc') {
          return 1
        }
        return 10
      },
      validate() {
        this.$validator.validate().then((result) => {
          if(result) {
            this.build()
          } else {
            this.$snotify.error("Please correct the errors shown below.", "Error", {
              timeout: 7500
            })
            this.$scrollTo('#contentTop')
          }
        })
      },
      build() {
        var i;
        for(i = 0; i < this.counts.eduNum; i++) {
          this.verifications.push({
            firstname: this.firstname,
            middlename: this.middlename,
            lastname: this.lastname,
            dob: this.dob,
            institute: null,
            customerReference: this.customerReference,
            type: 'education',
            new: true
          })
        }
        for(i = 0; i < this.counts.pliNum; i++) {
          this.verifications.push({
            firstname: this.firstname,
            middlename: this.middlename,
            lastname: this.lastname,
            dob: this.dob,
            institute: null,
            customerReference: this.customerReference,
            type: 'proflic',
            new: true
          })
        }
        for(i = 0; i < this.counts.pceNum; i++) {
          this.verifications.push({
            firstname: this.firstname,
            middlename: this.middlename,
            lastname: this.lastname,
            dob: this.dob,
            institute: null,
            customerReference: this.customerReference,
            type: 'profcert',
            new: true
          })
        }
        for(i = 0; i < this.counts.hscNum; i++) {
          this.verifications.push({
            firstname: this.firstname,
            middlename: this.middlename,
            lastname: this.lastname,
            dob: this.dob,
            institute: null,
            customerReference: this.customerReference,
            type: 'highschool',
            subjects: [
              {name: null, mark: null}
            ],
            new: true
          })
        }
        for(i = 0; i < this.counts.empNum; i++) {
          this.verifications.push({
            firstname: this.firstname,
            middlename: this.middlename,
            lastname: this.lastname,
            dob: this.dob,
            institute: null,
            customerReference: this.customerReference,
            type: 'employment',
            new: true
          })
        }
        for(i = 0; i < this.counts.elcNum; i++) {
          this.verifications.push({
            firstname: this.firstname,
            middlename: this.middlename,
            lastname: this.lastname,
            dob: this.dob,
            institute: null,
            customerReference: this.customerReference,
            type: 'englishlang',
            new: true
          })
        }

        var institutesToFetch = []

        // if(this.counts.empNum > 0) {
        //   institutesToFetch.push(new Promise((resolve, reject) => {
        //   this.$service.buildInstitute("QC_EMP_VER")
        //     .then(response => {
        //       for(i = 0; i < this.counts.empNum; i++) {
        //         var institute = JSON.parse(JSON.stringify(response))
        //         this.verifications.push({
        //           firstname: this.firstname,
        //           middlename: this.middlename,
        //           lastname: this.lastname,
        //           dob: this.dob,
        //           institute: institute,
        //           customerReference: this.customerReference,
        //           type: 'employment',
        //           new: true
        //         })
        //       }
        //       resolve()
        //     })
        //     .catch(error => {
        //       reject()
        //     })
        //   })
        //   )
        // }

        if(this.counts.idcNum > 0) {
          institutesToFetch.push(new Promise((resolve, reject) => {
          this.$service.buildInstitute("QC_ID_VER_TRUST_ID")
            .then(response => {
              for(i = 0; i < this.counts.idcNum; i++) {
                var institute = JSON.parse(JSON.stringify(response))
                this.verifications.push({
                  firstname: this.firstname,
                  middlename: this.middlename,
                  lastname: this.lastname,
                  dob: this.dob,
                  institute: institute,
                  customerReference: this.customerReference,
                  type: 'idcheck',
                  new: true
                })
              }
              resolve()
            })
            .catch(error => {
              reject()
            })
          })
          )
        }

        if(this.counts.arfNum > 0) {
          institutesToFetch.push(new Promise((resolve, reject) => {
          this.$service.buildInstitute("QC_ARF_VER")
            .then(response => {
              for(i = 0; i < this.counts.arfNum; i++) {
                var institute = JSON.parse(JSON.stringify(response))
                this.verifications.push({
                  firstname: this.firstname,
                  middlename: this.middlename,
                  lastname: this.lastname,
                  dob: this.dob,
                  institute: institute,
                  customerReference: this.customerReference,
                  type: 'academicref',
                  new: true
                })
              }
              resolve()
            })
            .catch(error => {
              reject()
            })
          })
          )
        }

        if(institutesToFetch.length > 0) {
          var loading = Loading.service({
            spinner: 'qc-spinner',
            text: 'Adding new verifications.'
          })

          Promise.all(institutesToFetch)
            .then(responses => {
              loading.close()
              this.$emit('started')
            })
            .catch(error => {
              loading.close()
              console.log(error)
              this.$snotify.error("Error adding new verifications. Please try again.", "Error", {
                timeout: 7500
              })
            })

        } else {
          this.$emit('started')
        }
      }
    }
  }
</script>

<style scoped>
div[data-lastpass-icon-root] { display: none; }
div[data-lastpass-root] { display: none; }
</style>

